import { FC } from 'react';
import SunshineTag from '@shinetools/invoicing-renderer/dist/components/_core/SunshineTag';
import { ColorName } from '@shinetools/sunshine';
import { isAfter } from 'date-fns';

import { IconName } from 'components/_core/SunshineIcon';

import locales from '../../locales';

interface TaxStatusProps {
  isPaid: boolean;
  payBefore: number;
}

const TaxStatus: FC<TaxStatusProps> = ({ isPaid, payBefore }) => {
  let colorSchema: ColorName;
  let icon: IconName;
  let text: string;

  const isInLatePayment = !isPaid && isAfter(Date.now(), new Date(payBefore));

  if (isPaid) {
    colorSchema = 'green';
    icon = 'tick';
    text = locales.taxDetails.status.paid;
  } else if (isInLatePayment) {
    colorSchema = 'red';
    icon = 'warning';
    text = locales.taxDetails.status.late;
  } else {
    // here, the tax status is pending
    colorSchema = 'yellow';
    icon = 'hourglass';
    text = locales.taxDetails.status.pending;
  }

  return (
    <SunshineTag colorScheme={colorSchema} icon={icon} size="sm">
      {text}
    </SunshineTag>
  );
};

export default TaxStatus;
